<style lang="scss" scoped>


</style>

<template>
    <Alert type="info" :show="isAlert" >
        <template v-slot:title>Messabstand beachten</template>
        <template v-if="!isLastWithdrawalCompleted">
            Bitte beenden Sie zunächst die letzte Entnahme. Der Ruhewasserstand kann nur dokumentiert
            werden, wenn eine zuvor begonnene Entnahme beendet ist. 
        </template>
        <template v-else>
            Der Ruhewasserstand kann nur dokumentiert werden, wenn eine zuvor stattgefundene 
            Entnahme seit mindestens {{ config.logic.stillWaterLevelWithdrawalSpanHours }} Stunden
            beendet ist. Die letzte Entnahme fand vor {{ hoursSinceLastWithrawal }} Stunden statt.
        </template>
    </Alert>  
</template>

<script>
/* eslint-disable */

import Alert from '@/components/Alert.vue';
import * as dayjs from 'dayjs';

export default {
    name: 'LevelIntervalAlert',
    components: {
        Alert
    },
    inject: [
        'state',
        'config'
    ],
    props: {
        isAlert: {
          type: Boolean,
          default: false
        }
    },
    data: function () {
        return {
           
        }
    },
    computed: { 
        isDocumentationIntervallUnderrun: function () {
        
            if (!this.isLastWithdrawalCompleted) {
                return true;
            }
        
            let hours = this.hoursSinceLastWithrawal;
            
            if (!hours) {
                return false;
            }
            
            if (hours < this.config.logic.stillWaterLevelWithdrawalSpanHours) {
                return true;
            }
        
            return false;
        },
        hoursSinceLastWithrawal: function () {
            let lastWithdrawal = this.state.withdrawal.item(null, 'dateLast');
            
            if (!lastWithdrawal) {
                return null;
            }
            
            return dayjs().diff(lastWithdrawal.datetime, 'hours');
        },
        isLastWithdrawalCompleted: function () { 
            const lastWithdrawal = this.state.withdrawal.item(null, 'dateLast');
            
            if ( !lastWithdrawal ) {
                return true;
            }
                       
            if ( lastWithdrawal.countEnd > 0) {
                return true;
            }
            return false;            
        }       
    },
    methods: {
        
    },
    watch: {    
        isDocumentationIntervallUnderrun: function (new_value, old_value) {
            if ( old_value === false && new_value === true ) {
                this.$emit('update:isAlert', true);
            } 
            
            if ( old_value === true && new_value === false ) {
                this.$emit('update:isAlert', false);
            } 
        }
    },
    mounted: function () {
        this.$emit('update:isAlert', this.isDocumentationIntervallUnderrun);
    }
}

</script>